
import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import {
    Container,
    Row,
    Col,
} from 'reactstrap';

import Isvg from 'react-inlinesvg';
import image from '../../../assets/svg/image.svg';
import { Editor } from '@tinymce/tinymce-react';

class Image extends Component {
    constructor(props) {
        super(props);
        this.selectFile = this.selectFile.bind(this);

        this.state = {

        };
    }

    selectFile(e) {
        let input = e.target;
        if (input.files && input.files[0]) {
            var reader = new FileReader();

            reader.onload = async (e) => {
                this.setState({
                    _loading: true
                })
                fetch('https://dpsklas.novamedia.agency/admin/upload', {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('token')}`

                    },
                    body: JSON.stringify({image: e.target.result})
                }).then((res) => res.text()).then((img) => {
                    this.props.onChange(img);
                    this.setState({
                        _loading: null
                    })
                });
        
            }

            reader.readAsDataURL(input.files[0]);
        }
    }

    render() {
        return (
                        <div className="image-picker single-image-picker">
                            <input type="file" onChange={this.selectFile} />
                            {this.props.value ?
                                <img src={this.props.value} />
                                :
                                <div className="no-image">
                                    <Isvg src={image} />
                                    <span className="text">Izaberite sliku</span>
                                    {
                                        this.state._loading ?
                                        <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
                                        :
                                        null
                                    }
                                </div>
                            }
                        </div>


        );
    }
}

export default Image;